
define('text!platform/commonUI/general/res/templates/tree/node.html',[],function () { return '<span class="tree-item menus-to-left">\n</span>\n<span class="tree-item-subtree">\n</span>\n';});

